//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Flag for how fee items should be displayed/required by user */
export const RegistrationFeeType = {
    /** There is one only one option for this fee */
    Single: 0,

    /** There are multiple options available for this fee */
    Multiple: 1
} as const;

/** Flag for how fee items should be displayed/required by user */
export const RegistrationFeeTypeDescription: Record<number, string> = {
    0: "Single",

    1: "Multiple"
};

/** Flag for how fee items should be displayed/required by user */
export type RegistrationFeeType = typeof RegistrationFeeType[keyof typeof RegistrationFeeType];
